import React, { useCallback, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { useDispatch } from 'react-redux';
import CreateEditUser from './CreateEditUser';

export default function AddEditUserModal({
  isOpen,
  toggle,
  isEditMode,
  selectedUser,
  domain,
  customRoles,
  onSuccess,
  isUserPath,
  operatorUser,
  operatorId
}) {
  const dispatch = useDispatch();

  // Cleanup and scroll management
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  const handleCancel = useCallback(() => {
    toggle();
  }, [toggle]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      className="custom-modal"
      backdrop="static"
    >
      <button
        type="button"
        className="close-button-currency mt-n1"
        onClick={toggle}
      >
        &times;
      </button>
      <h5 className="text-center w-100 fw-semibold py-3 rv-breadcrumb-border">
        {isEditMode ? "Edit User" : "Add User"}
      </h5>
      <ModalBody className="model-padding">
        <CreateEditUser
          isEditMode={isEditMode}
          userInformation={selectedUser}
          onCancel={handleCancel}
          onSuccess={onSuccess}
          isUserPath={isUserPath}
          customRoles={customRoles}
          domain={domain}
          isGroupedOptions={isUserPath && !isEditMode ? true : false}
          operatorUser={operatorUser}
          operatorId={operatorId}
        />
      </ModalBody>
    </Modal>
  );
}
